(function () {
  const btn = document.getElementById('scroll-to-top-btn');
  if (!btn) return;

  const threshold = window.innerHeight;

  function onScroll() {
    if (window.scrollY > threshold) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
